import "tinymce/themes/silver/theme";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount";
import "tinymce/icons/default/icons";
import "tinymce/themes/silver";
import "tinymce/plugins/media";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/preview";
import "tinymce/plugins/advlist";
import "tinymce/plugins/codesample";
import "tinymce/plugins/hr";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/textpattern";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/autolink";
import "tinymce/plugins/directionality";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/template";
import "tinymce/plugins/charmap";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/imagetools";
import "tinymce/plugins/autosave";
import "tinymce/plugins/autoresize";
import "tinymce/plugins/paste";
import "tinymce/plugins/print";
import "tinymce/plugins/quickbars";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/bbcode";
import "tinymce/plugins/tabfocus";
import "tinymce/plugins/help";
const isIE = function() {
    //ie?
    if (!!window.ActiveXObject || "ActiveXObject" in window) return true;
    else return false;
}
export default {
    cleanup : true,
    language: 'zh_CN',
    plugins: 'print preview searchreplace autolink directionality visualblocks visualchars fullscreen link media template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help emoticons autosave bdmap indent2em autoresize formatpainter axupimgs',
    toolbar: 'code undo redo restoredraft | powerpaste | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | table media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter', // axupimgs 多图上传
    height: 650, //编辑器高度
    min_height: 400,
    // skin: 'oxide-dark',
    fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
    font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',
    link_list: [

    ],
    // 工具栏展开方式
    toolbar_mode:'sliding',
    entity_encoding:'raw',
    // 是否允许拖动
    resize:false,
    image_list: [

    ],
    init_instance_callback: function(editor){
        editor.on('paste',function(e){
            setTimeout(function(){
                // 获取光标最后的位置
                var p = editor.selection.getBookmark(2);
                var content = editor.getContent().replace(/windowtext/g,'black');
                content = content.replace(/font-family: 微软雅黑;/g,'font-family: Microsoft YaHei;');
                content = content.replace(/border="0"/g,'border="1"');
                if(isIE()){
                    content = content.replace(/background-color: transparent;/g,'');
                }
                editor.setContent(content)
                editor.selection.moveToBookmark(p);
            },500)

        });
    },
    image_class_list: [
        { title: 'None', value: '' },
        { title: 'Some class', value: 'class-name' }
    ],
    importcss_append: true,
    //自定义文件选择器的回调内容
    file_picker_callback: function (callback, value, meta) {

    },
    // images_upload_handler: function (blobInfo, succFun, failFun) {
    //     window.images_upload_handler(blobInfo, succFun, failFun)
    // },
    powerpaste_word_import: 'clear',// 参数可以是propmt, merge, clear，效果自行切换对比
    powerpaste_html_import: 'clear',// propmt, merge, clear
    powerpaste_allow_local_images: true,
    paste_data_images: true,
    toolbar_sticky: true,
    autosave_ask_before_unload: false,
}
